import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange, handlePageSizeChange, handleLagOffsetChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { workspaceThrottleEnabled, workspaceStoreFullMessage, pageSize, lagOffset } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  const internalHandlePageSizeChange = (e) => {
    const { value } = e.target;
    onChange(e);
    if (value >= 1e3) {
      handlePageSizeChange("");
    } else {
      handlePageSizeChange(t("googleworkspacev2.advanced.page_size_min_error"));
    }
  };
  const internalHandleLagOffsetChange = (e) => {
    const { value } = e.target;
    if (value >= 0) {
      onChange(e);
      handleLagOffsetChange("");
    } else {
      handleLagOffsetChange(t("googleworkspacev2.advanced.lag_offset_negative_error"));
    }
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(
      ThrottlingCheckbox,
      {
        id: "wrokspaceThrottleEnabled",
        defaultChecked: workspaceThrottleEnabled == null ? void 0 : workspaceThrottleEnabled.value,
        onChange
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pageSize",
        type: "number",
        value: pageSize.value,
        min: "1000",
        onChange: internalHandlePageSizeChange,
        required: true,
        help: t("googleworkspacev2.advanced.page_size_help"),
        label: t("googleworkspacev2.advanced.page_size")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "lagOffset",
        type: "number",
        value: lagOffset.value,
        min: "0",
        onChange: internalHandleLagOffsetChange,
        required: true,
        help: t("googleworkspacev2.advanced.lag_offset_help"),
        label: t("googleworkspacev2.advanced.lag_offset")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "workspaceStoreFullMessage",
        type: "checkbox",
        value: "enable-storeFullMessage",
        defaultChecked: workspaceStoreFullMessage == null ? void 0 : workspaceStoreFullMessage.value,
        onChange,
        label: t("common.fields.store_full_message"),
        help: t("googleworkspacev2.advanced.store_full_message_help")
      }
    )
  );
};
export default FormAdvancedOptions;
